import { createContext } from 'react';

const CMSContext = createContext({});

export default CMSContext;
